import { createContext, useContext } from "react";
import { type PillarModalControl } from "shared/components/pillar-modal/usePillarModalControl";
import type { WebsocketNotificationEvent } from "shared/types/notification-event";

export type NotificationsContextType = {
  disabled: boolean;
  pushDisabled: boolean;
  socketDisabled: boolean;
  notificationsDisabled: boolean;
  chatMessagesDisabled: boolean;
  notificationsModalControl: PillarModalControl;
  unreadNotificationsCount?: number;
  lastMessage: WebsocketNotificationEvent | null;
};

export const NotificationsContext =
  createContext<NotificationsContextType | null>(null);

export const useNotificationsContext = (): NotificationsContextType => {
  const notificationsContext = useContext(NotificationsContext);
  if (notificationsContext === undefined) {
    throw new Error(
      "useNotificationsContext must be used within a NotificationsContext",
    );
  }
  if (notificationsContext === null) {
    throw new Error("NotificationsContext is null");
  }
  return notificationsContext;
};
